import { Play } from "@phosphor-icons/react";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";
import ScrollStrip from "./ScrollStrip";

function getEmbed(url) {
    if (!url) return null;
    const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]+)/);
    if (yt) return { portrait: url.includes("/shorts/"), src: `https://www.youtube.com/embed/${yt[1]}` };
    const ig = url.match(/instagram\.com\/(p|reel|reels)\/([\w-]+)/);
    if (ig) return { portrait: true, src: `https://www.instagram.com/${ig[1]}/${ig[2]}/embed` };
    return null;
}

export default function Video({ videos }) {
    const { t } = useLang();
    const items = videos.map((v) => ({ ...v, embed: getEmbed(v.url) })).filter((v) => v.embed);

    return (
        <section id="video" className="py-24 md:py-32 border-t border-racing-line bg-[#FBF9F5]" data-testid="video-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="08" title={t.ch_video_t} subtitle={t.ch_video_s} />

                {items.length === 0 ? (
                    <p className="text-racing-muted" data-testid="video-empty">{t.video_empty}</p>
                ) : (
                    <Reveal>
                        <ScrollStrip testid="video-strip" gapClass="gap-6">
                            {items.map((v, i) => (
                                <figure
                                    key={v.id}
                                    data-testid={`video-card-${i}`}
                                    className={`shrink-0 snap-start border border-racing-line bg-white overflow-hidden ${v.embed.portrait ? "w-[300px] md:w-[340px]" : "w-[86%] sm:w-[520px] md:w-[600px]"}`}
                                >
                                    <div className={v.embed.portrait ? "w-full h-[520px]" : "aspect-video w-full"}>
                                        <iframe
                                            src={v.embed.src}
                                            title={v.title}
                                            className="w-full h-full"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        />
                                    </div>
                                    <figcaption className="flex items-center gap-3 px-5 py-4 border-t border-racing-line">
                                        <Play size={18} weight="fill" className="text-racing-red shrink-0" />
                                        <span className="text-sm font-medium text-neutral-900">{v.title}</span>
                                    </figcaption>
                                </figure>
                            ))}
                        </ScrollStrip>
                    </Reveal>
                )}
            </div>
        </section>
    );
}
